
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Operators`}</h1>
<p>{`Use `}<inlineCode parentName="p">{`===`}</inlineCode>{` and `}<inlineCode parentName="p">{`!==`}</inlineCode>{` intead of `}<inlineCode parentName="p">{`==`}</inlineCode>{` and `}<inlineCode parentName="p">{`!=`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because `}<inlineCode parentName="p">{`==`}</inlineCode>{` and `}<inlineCode parentName="p">{`!=`}</inlineCode>{` perform type coercion before making the comparison so `}<inlineCode parentName="p">{`2 == '2'`}</inlineCode>{` would be equal.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
if (foo == 'bar' || foo != 'baz') {
  // ... more code ...
}

// Good
if (foo === 'bar' || foo !== 'baz') {
  // ... more code ...
}
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`== null`}</inlineCode>{` or `}<inlineCode parentName="p">{`!= null`}</inlineCode>{` when comparing for `}<inlineCode parentName="p">{`null`}</inlineCode>{` or `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` values.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if ( ! foo) {
}

// Good
if (foo != null) {
}
`}</code></pre>
<p>{`Always use explicit comparisons.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if (foo) {
  // ... more code ...
}

// Good
if (foo !== '') {
  // ... more code ...
}

if (foo != null) {
  // ... more code ...
}

if (foo !== 0) {
  // ... more code ...
}
`}</code></pre>
<p>{`Always use simple comparisons for boolean values.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if (isAlive !== false) {
  // ... more code ...
}

if (isOpen === false) {
  // ... more code ...
}

// Good
if (isAlive) {
  // ... more code ...
}

if ( ! isOpen) {
  // ... more code ...
}
`}</code></pre>
<p>{`Never nest ternary operators.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const foo = isOk ? isM ? 'John' : 'Jane' : null;

// Good
const name = isM ? 'John' : 'Jane';
const foo = isOk ? name : null; 
`}</code></pre>
<p>{`Avoid unnecessary ternary operators.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const foo = a ? true : false;

// Good
const foo = Boolean(a);
`}</code></pre>
<p>{`When mixing logical operators, always put them in between parentheses.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const foo = a > 0 && b < 0 || c > 0 && d + 1 === 0;

// Good
const foo = (a > 0 && b < 0) || (c < 0 && d + 1 === 0);
`}</code></pre>
<p>{`Never use increment or decrement operators. Use the assignment form instead.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
let foo = 0;
foo++;
foo--;
console.log(foo);  // prints 0

// Good
let foo = 0;
foo += 1;
foo -= 1;
console.log(foo);  // prints 0
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;